/**
 * useNews — Task #16-FE
 *
 * Holt die News-Liste vom Backend (GET /api/v2/news).
 * Typen aus @heliumtracker/api-types (NewsItem-Schema).
 */
import { useApi } from '../../lib/use-api'
import apiClient from '../../lib/api-client'
import type { components } from '@heliumtracker/api-types'

export type NewsItem = components['schemas']['NewsItem']

type UseNewsResult = {
  data: NewsItem[] | undefined
  isLoading: boolean
  isError: boolean
}

export function useNews(): UseNewsResult {
  const query = useApi<{ data: NewsItem[] }>(
    ['news'],
    () => apiClient.GET('/api/v2/news'),
  )

  return {
    data: query.data?.data,
    isLoading: query.isLoading,
    isError: query.isError,
  }
}
